import { LeadingComment } from '@angular/compiler';
import { Injectable } from '@angular/core';
import { DataService } from './data.service';

@Injectable()
export class DriverService {

    route = '/api/driver';

    constructor(private dataService: DataService) {
    };

    get(data: any, refresh: boolean) {
        return this.dataService.getData('/api/driver/' + data.region + '/' + data.division + '/' + data.subdivision+'/'+data.statusType+'/'+data.financialYearId, refresh);
    }
    getLookUp(id: number, refresh: Boolean) {
        return this.dataService.getData(this.route + '/lookup', refresh);
    }

    getById(id: number,financialYearId:number) {
        return this.dataService.getRecord(this.route + '/' + id + '/' + financialYearId);
    }

    save(data: any) {
        return this.dataService.post(this.route, data).map(response => {
            return response;
        });
    }

    delete(id: number) {
        return this.dataService.post('/api/driver/delete/' + id, null).map(response => {
            this.dataService.clearCache();
            this.dataService.clearRouteCache(this.route);
            return response;
        });
    }

    getLicenses(refresh: boolean) {
        return this.dataService.getData('/api/driver/lookup', refresh);
    }

    getDriverLookUp(data: any, refresh: Boolean) {
        return this.dataService.getData('/api/lookup/driver/' + data.subDivisionId + '/' + data.deviceId, refresh);
    }
    
    getBlocklist( subdivisionId: number, refresh: boolean) {
        return this.dataService.getData('/api/subdivision/allblocklist/'+ subdivisionId, refresh);
    }

getBlocklistbydistict( divisionId: number, Langtype:any, refresh: boolean) {
    return this.dataService.getData('/api/mhire/block/'+ divisionId + '/' + Langtype,refresh);
}


    getStateLookUp(refresh: Boolean) {
        return this.dataService.getData('/api/lookup/state', refresh);
    }

    downloadAttachment(id: number, refresh: boolean) {
        return this.dataService.getData('/api/driver/attachment/' + id, refresh);
    }

    driverType(refresh: boolean) {
        return this.dataService.getData('/api/lookup/drivertype', refresh);
    }

    getEducationList(refresh: boolean) {
        return this.dataService.getData('/api/lookup/eduqualificationtype', refresh);
    }

    getGenderList(refresh: boolean) {
        return this.dataService.getData('/api/lookup/gendertype', refresh);
    }

    getDriverEmpType(refresh: boolean) {
        return this.dataService.getData('/api/lookup/employmenttype', refresh);
    }

    getLicenseType(refresh: boolean) {
        return this.dataService.getData('/api/lookup/licensetype', refresh);
    }

    getDriverSkillList(refresh: boolean) {
        return this.dataService.getData('/api/lookup/driverskill', refresh);
    }
    getDriverLookUpByRegId(id:number, refresh: Boolean) {
        return this.dataService.getData('/api/driver/lookupbysubdivision/' + id, refresh);
    }
    getDriverLookUpByLogBook(id:number, refresh: Boolean) {
        return this.dataService.getData('/api/driver/logbooklookupbysubdivision/' + id, refresh);
    }


    getmhireAllocateDriver(driverData:any, refresh: Boolean) {
        return this.dataService.getData('/api/driver/mhireAllocateDriver/' +driverData.bookingId + '/' +driverData.subDivisionId + '/' + driverData.vehicleId + '/' + driverData.startDate + '/' + driverData.endDate , refresh);
    }
   
}
